import React from 'react'
import { useDispatch } from 'react-redux'

import getWallet from '../../api/wallet'
import { setWallet } from '../../store/wallet/wallet'

import { Button } from '../Button/Button'
import { LinkButton } from '../LinkButton/LinkButton'

import cat1 from '../../assets/img/cat_1.png'
import cat2 from '../../assets/img/cat_2.png'

import './NoWalletState.scss'

export const NoWalletState = () => {
  const dispatch = useDispatch()

  const connect = () => {
    getWallet()
      .then(res => {
        dispatch(setWallet(res))
      })
      .catch(console.log)
  }

  return (
    <div className="no-wallet-state">
    <div className="section">
      <img src={ cat2 } alt="cat" />
      <Button
        label="连接钱包"
        color="red"
        onClick={ connect }
      />
    </div>
      <span className="or">
        OR
      </span>
      <div className="section">
        <img src={ cat1 } alt="cat" />
        <LinkButton
          label="安装 TRONLINK "
          color="blue"
          link="https://www.tronlink.org/"
          inNewTab
        />
      </div>
    </div>
  )
}